// extracted by mini-css-extract-plugin
export default {"signInButton":"ResetPasswordPage_signInButton__p3yGJ","signUpButton":"ResetPasswordPage_signUpButton__2mcTT","form":"ResetPasswordPage_form__sdikY"};